export default {
    currentColorScheme: state => state.colorSchemes[state.colorSchemeId],
};
